import React from "react";
import "./app.scss";
import { graphClient } from "./client/graphClient";
import { ApolloProvider } from "@apollo/client";
import { HashRouter } from "react-router-dom";
import PageRoter from "./pages/PageRouter";
import Header from "./components/Header/Header";

function App(): JSX.Element {
  return (
    <ApolloProvider client={graphClient}>
      <HashRouter>
        <div className="App">
          <Header />
          <PageRoter />
        </div>
      </HashRouter>
    </ApolloProvider>
  );
}

export default App;
